import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { BackButtonComponent } from './back-button.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [BackButtonComponent],
  exports: [BackButtonComponent],
  providers: [],
})
export class BackButtonComponentModule {}
